module.exports = __webpack_public_path__ + "img/gallery06.c76153a9.jpg";